import { render } from "./UserBookings.vue?vue&type=template&id=2359b4ed&scoped=true"
import script from "./UserBookings.vue?vue&type=script&lang=js"
export * from "./UserBookings.vue?vue&type=script&lang=js"

import "./UserBookings.vue?vue&type=style&index=0&id=2359b4ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2359b4ed"]])

export default __exports__